import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, FileText } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const PAGES = [
  {
    key: "about",
    label: "Hakkımızda",
    fields: [
      { key: "headline", label: "Üst Başlık", type: "text", placeholder: "Yarım asra uzanan ustalık..." },
      { key: "intro", label: "Tanıtım Yazısı", type: "textarea", rows: 6, placeholder: "Firma hikayesi..." },
      { key: "mission", label: "Misyon Metni", type: "textarea", rows: 4, placeholder: "Yapıların ömrünü uzatmak..." },
      { key: "cta_text", label: "Alt CTA Metni", type: "text", placeholder: "Bir sonraki projeniz için..." },
    ],
  },
  {
    key: "home_intro",
    label: "Anasayfa Açıklamaları",
    fields: [
      { key: "hero_subtitle", label: "Hero Alt Yazısı", type: "textarea", rows: 3, placeholder: "Su, çatı ve ısı yalıtımında..." },
      { key: "references_intro", label: "Referanslar Bölüm Açıklaması", type: "textarea", rows: 3 },
    ],
  },
  {
    key: "services_intro",
    label: "Hizmetler Açıklaması",
    fields: [
      { key: "intro", label: "Hizmetler Genel Açıklaması", type: "textarea", rows: 4 },
    ],
  },
  {
    key: "contact_intro",
    label: "İletişim Açıklaması",
    fields: [
      { key: "intro", label: "İletişim Sayfası Metni", type: "textarea", rows: 3 },
    ],
  },
];

export default function Content() {
  const [active, setActive] = useState(PAGES[0].key);
  const [data, setData] = useState({});
  const [busy, setBusy] = useState(false);

  const current = PAGES.find((p) => p.key === active);

  useEffect(() => {
    api.get(`/site-content/${active}`).then((r) => setData(r.data?.content || {})).catch(() => setData({}));
  }, [active]);

  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/site-content/${active}`, { content: data });
      toast.success("İçerik kaydedildi");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="content-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">İçerik</p>
      <h1 className="mt-2 font-display font-extrabold tracking-tighter text-4xl md:text-5xl">Sayfa İçerikleri</h1>
      <p className="text-white/55 text-sm mt-2">Buradan değiştirdiğiniz metinler ilgili sayfalarda anında yansır.</p>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <aside className="lg:col-span-3 space-y-1">
          {PAGES.map((p) => (
            <button
              key={p.key}
              onClick={() => setActive(p.key)}
              data-testid={`content-tab-${p.key}`}
              className={`w-full text-left flex items-center gap-3 px-3 py-2.5 text-sm transition border-l-2 ${active === p.key ? "bg-[#d4af37]/10 text-[#d4af37] border-[#d4af37]" : "text-white/70 border-transparent hover:text-white hover:bg-white/5"}`}
            >
              <FileText className="h-4 w-4" />
              {p.label}
            </button>
          ))}
        </aside>
        <div className="lg:col-span-9 border border-white/8 bg-[#121212] p-6 md:p-8">
          <div className="font-display text-2xl tracking-tight">{current.label}</div>
          <div className="mt-6 space-y-5">
            {current.fields.map((f) => (
              <label key={f.key} className="block">
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/45 mb-2">{f.label}</div>
                {f.type === "textarea" ? (
                  <textarea
                    rows={f.rows || 4}
                    value={data[f.key] || ""}
                    onChange={(e) => setData({ ...data, [f.key]: e.target.value })}
                    placeholder={f.placeholder}
                    data-testid={`content-field-${active}-${f.key}`}
                    className="w-full bg-transparent border border-white/12 focus:border-[#d4af37] outline-none p-3 text-white resize-none"
                  />
                ) : (
                  <input
                    type="text"
                    value={data[f.key] || ""}
                    onChange={(e) => setData({ ...data, [f.key]: e.target.value })}
                    placeholder={f.placeholder}
                    data-testid={`content-field-${active}-${f.key}`}
                    className="w-full bg-transparent border border-white/12 focus:border-[#d4af37] outline-none p-3 text-white"
                  />
                )}
              </label>
            ))}
          </div>
          <button
            onClick={save}
            disabled={busy}
            data-testid="content-save"
            className="mt-7 inline-flex items-center gap-2 bg-[#d4af37] text-[#121212] hover:bg-white disabled:opacity-60 px-6 py-3 font-display uppercase tracking-[0.18em] text-xs transition"
          >
            <Save className="h-4 w-4" /> {busy ? "Kaydediliyor..." : "Kaydet"}
          </button>
        </div>
      </div>
    </div>
  );
}
